import React from 'react';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

function Name({ item, selectFile }) {
  const { modals, setSelectedItem } = useFileManagerContext();

  function handleVersionControlClick(e) {
    e.stopPropagation();
    setSelectedItem(item);
    modals.setShowUploadedVersionsModal(true);
  }

  return (
    <div className="d-flex w-100 fileManager-title">
      <div
        className="d-inline-block text-truncate text-primary-dark text-decoration-none text-bold cursor-pointer w-100 px-1 py-3"
        title={item.display_name}
        // onClick={() => selectFile(item)}
      >
        {item.display_name}
      </div>

      {item.entry_type !== 'folder' && item?.versions?.length > 0 && (
        <i
          className="fas fa-history"
          style={{ display: 'flex', alignItems: 'center', marginRight: '10px', color: '#2655B9' }}
          title="Version history"
          onClick={handleVersionControlClick}
        />
      )}
    </div>
  );
}

export default Name;
